import { Box, Breadcrumbs, Button, Card, CardContent, Container, Divider, Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

function AdminGroupViewer() {
    const { groupId } = useParams();

    return (
        <>
            {/** Breadcrumbs */}
            <Container sx={{ marginY: 2 }}>
                <Breadcrumbs sx={{ my: 1 }}>
                    <div>Admin</div>
                    <div>Groups</div>
                    <div>{groupId}</div>
                </Breadcrumbs>
                <Divider />
            </Container>

            {/** Content */}
            <Container sx={{ marginY: 3 }}>
                <Typography variant="h1" fontSize={34} fontWeight="bold">
                    Group NAME-{groupId}
                </Typography>

                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Typography variant="h6" fontWeight="bold">
                            Information
                        </Typography>
                        <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                        <Divider />
                        ...
                    </CardContent>
                </Card>

                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Typography variant="h6" fontWeight="bold">
                            Workspace
                        </Typography>
                        <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                        <Divider />
                        ...
                    </CardContent>
                </Card>

                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Box sx={{ display: "flex" }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" fontWeight="bold">
                                    Parent Group
                                </Typography>
                                <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                            </Box>
                            <Box>
                                <Button variant="outlined">Add</Button>
                            </Box>
                        </Box>
                        <Divider />
                        ...
                    </CardContent>
                </Card>

                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Box sx={{ display: "flex" }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" fontWeight="bold">
                                    Children Group
                                </Typography>
                                <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                            </Box>
                            <Box>
                                <Button variant="outlined">Add</Button>
                            </Box>
                        </Box>
                        <Divider />
                        ...
                    </CardContent>
                </Card>

                {/**
                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Typography variant="h6" fontWeight="bold">
                            Group Hierarchy
                        </Typography>
                        <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                        <Divider />

                        <Box>Parent</Box>
                        <Box>Children</Box>
                    </CardContent>
                </Card>
                 */}

                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Box sx={{ display: "flex" }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" fontWeight="bold">
                                    Members
                                </Typography>
                                <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                            </Box>
                            <Box>
                                <Button variant="outlined">Add</Button>
                            </Box>
                        </Box>
                        <Divider />
                        ...
                    </CardContent>
                </Card>

                <Card component={Paper} sx={{ marginY: 3 }}>
                    <CardContent>
                        <Typography variant="h6" fontWeight="bold">
                            Setting
                        </Typography>
                        <Typography color="text.secondary">░░░░░░░░░░░░░░░░░░░░</Typography>
                        <Divider />
                        ...
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}

export default AdminGroupViewer;
